module.exports = __webpack_public_path__ + "img/trash-icon.05b5f8fe.svg";